import { Icon, Menu, Dropdown } from 'ant-design-vue'
import i18nMixin from '@/store/i18n-mixin'

const locales = ['zh-CN', 'en-US', 'es-ES', 'ar-SA']
const languageLabels = {
  'zh-CN': '简体中文',
  'en-US': 'English',
  'es-ES': 'Español',
  'ar-SA': 'العربية'
}
// eslint-disable-next-line
const languageIcons = {
  'zh-CN': '🇨🇳',
  'en-US': '🇺🇸',
  'es-ES': '🇪🇸',
  'ar-SA': '🇸🇦'
}

const SelectLang = {
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-drop-down'
    }
  },
  name: 'SelectLang',
  mixins: [i18nMixin],
  render () {
    const { prefixCls } = this
    const changeLang = ({ key }) => {
      this.setLang(key)
    }
    const langMenu = (
      <Menu class={['menu', 'ant-pro-header-menu']} selectedKeys={[this.currentLang]} onClick={changeLang}>
        {locales.map(locale => (
          <Menu.Item key={locale}>
            <span role="img" aria-label={languageLabels[locale]}>
              {languageIcons[locale]}
            </span>{' '}
            {languageLabels[locale]}
          </Menu.Item>
        ))}
      </Menu>
    )
    return (
      <Dropdown overlay={langMenu} placement="bottomRight">
        <div class={prefixCls}>
          <Icon type="global" style={{ fontSize: '20px', cursor: 'pointer' }} />
        </div>
      </Dropdown>
    )
  }
}

export default SelectLang
